import { useEffect } from 'react';

import { useAppPerformanceContext } from './AppPerformanceContext';
import { PerformanceTrackingConfig } from './AppPerformanceContext.types';

export * from './AppPerformanceContext';
export * from './AppPerformanceContext.types';

export const useTrackComponent = (
  componentName: string,
  config?: PerformanceTrackingConfig
) => {
  const { trackComponent } = useAppPerformanceContext();
  useEffect(() => {
    trackComponent(componentName, config);
  });
};
